var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeSlotClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1C8.757 1 11 3.243 11 6C11 8.757 8.757 11 6 11C3.243 11 1 8.757 1 6C1 3.243 3.243 1 6 1ZM6 1.75C3.6565 1.75 1.75 3.6565 1.75 6C1.75 8.3435 3.6565 10.25 6 10.25C8.3435 10.25 10.25 8.3435 10.25 6C10.25 3.6565 8.3435 1.75 6 1.75ZM5.8306 3.5477C6.0381 3.5477 6.2056 3.7157 6.2056 3.9227V6.1337L7.9081 7.1487C8.0856 7.2552 8.1441 7.4852 8.0381 7.6632C7.9676 7.7807 7.8431 7.8462 7.7156 7.8462C7.6501 7.8462 7.5841 7.8292 7.5236 7.7937L5.6386 6.6692C5.5256 6.6012 5.4556 6.4787 5.4556 6.3467V3.9227C5.4556 3.7157 5.6236 3.5477 5.8306 3.5477Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeSlotClock);
export default __webpack_public_path__ + "static/media/time-slot-clock.5b28669eba5600ba765a93220ff1b16e.svg";
export { ForwardRef as ReactComponent };